import { CATEGORIES_ALL } from "./constants";
import { store } from "../store/store";
import keycloak from "./keycloak";

export const no_op = () => undefined;

export const isFunction = (obj) => !!(obj && obj.constructor && obj.call && obj.apply);

export const isString = (string) => typeof string === "string" || string instanceof String;

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const formatTime = (timeline) => {
  const date = new Date(timeline * 1000);
  const hours = date.getHours() >= 10 ? date.getHours() : "0" + date.getHours();
  const minutes = date.getMinutes() > 10 ? date.getMinutes() : "0" + date.getMinutes();
  const seconds = date.getSeconds() > 10 ? date.getSeconds() : "0" + date.getSeconds();
  return hours + ":" + minutes + ":" + seconds;
};

export const formatCategoriesList = (categoriesSelected) => {
  const categories = store.getState().searchOmim.categories;
  let cats = { ...categoriesSelected };

  const formattedCategories = [];
  for (const superCat of Object.keys(cats)) {
    const superCategory = categories.find((c) => c.text === superCat);

    if (superCategory?.subcategories?.length === 1 && superCategory?.subcategories[0].text === CATEGORIES_ALL) {
      const id = superCategory?.subcategories[0].id;
      formattedCategories.push(id);
    }

    if (!!Object.keys(cats[superCat])?.length) {
      for (const cat of Object.keys(cats[superCat])) {
        const category = superCategory?.subcategories.find((c) => c.text === cat);

        const allSubCategoriesSelected = category.subcategories?.length === Object.keys(cats[superCat][cat])?.length;
        const noSubCategoriesSelected = !Object.keys(cats[superCat][cat])?.length;

        if (
          (allSubCategoriesSelected || noSubCategoriesSelected) &&
          !(superCategory?.subcategories?.length === 1 && superCategory?.subcategories[0].text === CATEGORIES_ALL)
        ) {
          formattedCategories.push(category.id);
        } else if (!!Object.keys(cats[superCat][cat])?.length && !allSubCategoriesSelected) {
          for (const subCat of Object.keys(cats[superCat][cat])) {
            const subcategory = category.subcategories.find((c) => c.text === subCat);

            const allSecondSubCategoriesSelected =
              subcategory.subcategories?.length === Object.keys(cats[superCat][cat][subCat])?.length;
            const noSecondSubCategoriesSelected = !Object.keys(cats[superCat][cat][subCat])?.length;

            if (allSecondSubCategoriesSelected || noSecondSubCategoriesSelected) {
              const subId = category.subcategories.find((sub) => sub.text === subCat).id;
              formattedCategories.push(subId);
            } else {
              for (const secondSub of Object.keys(cats[superCat][cat][subCat])) {
                const secondSubId = category.subcategories
                  .find((sub) => sub.text === subCat)
                  .subcategories.find((sub) => sub.text === secondSub).id;
                formattedCategories.push(secondSubId);
              }
            }
          }
        }
      }
    }
  }

  return formattedCategories;
};

export const downloadPdf = (url, fileName) => {
  const xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);
  xhr.setRequestHeader("Authorization", `Bearer ${!!keycloak && !!keycloak.token ? keycloak.token : undefined}`);
  xhr.responseType = "arraybuffer";
  xhr.onload = function (e) {
    if (this.status === 200) {
      const blob = new Blob([this.response], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName + ".pdf";
      link.click();
    }
  };
  xhr.send();
};

export const isSearchSymptoms = (symptomSelected, symptoms) => {
  return symptoms.find((symptom) => symptom.name === symptomSelected);
};
